export enum EnumModalQueueItemType {
  Recruit = 'congratulate-recruit',
  Init = 'congratulate-init',
  Exit = 'topic-exit',
  Gift = 'common-gift',
  Coupon = 'order-coupon-gift'
}

export enum EnumRegisterModalNames {
  Topic = 'topic-modal',
  Gift = 'common-gift-modal',
  Coupon = 'order-coupon-gift-modal',
  Agreement = 'agreement-modal',
  GroupPopup = 'group-popup-modal',
  SatisfiedPopup = 'satisfied-popup-modal'
}

export enum EnumModalQueueItemCode {
  /**
   * 分桐开启招募通知
   */
  Recruit = 50100,
  /**
   * 分桐开启通知
   */
  Init = 50101,
  /**
   * 退出桐学会成功通知
   */
  Exit = 50102,
  /**
   * 领礼物通知
   */
  Gift = 50326,
  /**
   * 用户优惠券通知
   */
  Coupon = 50803,
  /**
   * 订单发券通知
   */
  OrderCoupon = 50804
}

export enum EnumModalOpStatus {
  // 确认
  Ok = 'ok',
  // 取消
  Cancel = 'cancel',
  // 仅关闭
  Close = 'close'
}
